import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tab from 'bootstrap/js/dist/tab';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Tooltip from 'bootstrap/js/dist/tooltip';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';

window.addEventListener('DOMContentLoaded', () => {
    // const offcanvasElement = document.getElementById('vue-bootstrap-offcanvas-container');
    // if (!offcanvasElement) {
    //     return;
    // }
    // const offcanvasInstance = new Offcanvas(offcanvasElement, {
    //     backdrop: 'static',
    //     keyboard: false,
    // });
    // const collapseElements = Array.from(document.querySelectorAll('.collapse'))
    // const collapseInstances = collapseElements.map(el => new Collapse(el))
    // const tabElements = Array.from(document.querySelectorAll('.nav-link'))
    // const tabInstances = tabElements.map(el => new Tab(el))
    // window.bootstrap.offcanvas = offcanvasInstance;
    // window.bootstrap = {
    //     // offcanvas: offcanvasInstance,
    //     // collapse: collapseInstances,
    //     // tab: tabInstances,
    // }
});

window.bootstrap = {
    Collapse,
    Modal,
    Offcanvas,
    Tab,
    Dropdown,
    Tooltip,
    ScrollSpy,
};

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
[...tooltipTriggerList].forEach((tooltipTriggerEl) => {
    if (tooltipTriggerEl.dataset.bsTitle) {
        tooltipTriggerEl.tooltip = new Tooltip(tooltipTriggerEl);
    }
});

// ['livewire.component.rendered'].forEach((event) => {
//     window.addEventListener(event, () => {
//         const collapseTriggerList = document.querySelectorAll('[data-bs-toggle="collapse"]');
//         [...collapseTriggerList].forEach((collapseTriggerEl) => {
//             const collapsedElements = document.querySelectorAll(collapseTriggerEl.dataset.bsTarget);

//             collapsedElements.forEach((collapsedElement) => {
//                 collapsedElement.collapse = new Collapse(collapsedElement);
//             });
//         });
//     });
// });
